import React from 'react';

function returnPath() {
  if (typeof window === 'undefined') return '/';
  return new URLSearchParams(window.location.search).get('from') === 'settings' ? '/settings' : '/';
}

export default function AppSupport() {
  const backToSettings = returnPath() === '/settings';
  return (
    <div className="app-container" style={{ maxWidth: 900, margin: '0 auto', paddingBottom: 48 }}>
      <button className="back-button" type="button" onClick={() => window.location.assign(returnPath())}>← {backToSettings ? 'Settings' : 'Line Medic'}</button>
      <h1>Line Medic App Support</h1>
      <p>
        Line Medic is an operational platform for authorized wildland medical programs, members, and administrators.
      </p>

      <h2>Account access</h2>
      <p>
        Sign in with the organization account or approved shared login provided by your Line Medic program administrator.
        New accounts must be preapproved or activated according to the organization’s configured access policy before
        operational features are available.
      </p>
      <p>
        If you forgot your password, use <strong>Forgot password?</strong> on the sign-in screen. If your account shows
        <strong>Access pending</strong> or <strong>Access disabled</strong>, contact your program administrator.
      </p>

      <h2>Camera scanning</h2>
      <p>
        Gear and inventory scanning may request access to the rear camera. If access was previously denied on iPhone,
        enable Camera permission for Line Medic in iPhone Settings, then reopen the scanner.
      </p>

      <h2>NFC gear tags</h2>
      <p>
        Gear tags use the permanent Line Medic asset URL printed in the QR code and stored on the NFC tag. If a tag opens
        but the asset is not accepted for Deploy or Return, verify that the physical asset is available, ready, and assigned
        to the correct member workflow.
      </p>

      <h2>Inventory or deployment problems</h2>
      <p>
        Do not bypass readiness, expiration, or required-gear warnings. If the application reports stale shared data,
        inventory unavailable, or another sync error, reconnect to the network and refresh before repeating the action.
      </p>

      <h2>Contact</h2>
      <p>
        For deployment-specific support, contact your organization’s Line Medic program administrator or configured support contact.
      </p>

      <p>
        <a href="/privacy">Privacy Policy</a>
      </p>
    </div>
  );
}
